import {ClientThemeName} from "@sparkware/uc-sdk-core";

export const ThemeName = {
    Casino888: ClientThemeName.Casino888,
    Casino888Cip: ClientThemeName.Casino888Cip,
    Casino888Cis: ClientThemeName.Casino888Cis,
    Casino777: ClientThemeName.Casino777,
    Harrahs: ClientThemeName.CasinoHarrahs,
    Wsop: ClientThemeName.CasinoWsop,
    WsopCip: ClientThemeName.CasinoWsopCip,
    BallysDover: ClientThemeName.CasinoBallysDover,
    Delawarepark: ClientThemeName.CasinoDelawarepark,
    Harrington: ClientThemeName.CasinoHarrington,
    SI: ClientThemeName.CasinoSI, //sports illustrator
    SICis: ClientThemeName.CasinoSICis,
    MrGreen: ClientThemeName.CasinoMrGreen,
}
